   <!--  <div class="row-options">
        <div class="option" (click)="setLayout('layout-class-1')">
            <div class="description">2 Dimension 1</div>
            <div class="preview-wrapper layout-class-1">
                <div class="bg-img-layer"></div>
                <div class="fill-layer"></div>
                <div class="content-layer">
                    <div class="header-container">
                        <div>Header</div>
                    </div>
                    <div class="text-container">
                        <div>Text</div>
                    </div>
                    <div class="footer-container">
                        <div>Footer</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="option" (click)="setLayout('layout-class-2')">
            <div class="description">2 Dimension 2</div>
            <div class="preview-wrapper layout-class-2">
                <div class="bg-img-layer"></div>
                <div class="fill-layer"></div>
                <div class="content-layer">
                    <div class="header-container">
                        <div>Header</div>
                    </div>
                    <div class="text-container">
                        <div>Text</div>
                    </div>
                    <div class="footer-container">
                        <div>Footer</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="option" (click)="setLayout('layout-class-3')">
            <div class="description">2 Dimension 3</div>
            <div class="preview-wrapper layout-class-3">
                <div class="bg-img-layer"></div>
                <div class="fill-layer"></div>
                <div class="content-layer">
                    <div class="header-container">
                        <div>Header</div>
                    </div>
                    <div class="text-container">
                        <div>Text</div>
                    </div>
                    <div class="footer-container">
                        <div>Footer</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="option" (click)="setLayout('layout-class-4')">
            <div class="description">2 Dimension 4</div>
            <div class="preview-wrapper layout-class-4">
                <div class="bg-img-layer"></div>
                <div class="fill-layer"></div>
                <div class="content-layer">
                    <div class="header-container">
                        <div>Header</div>
                    </div>
                    <div class="text-container">
                        <div>Text</div>
                    </div>
                    <div class="footer-container">
                        <div>Footer</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="option" (click)="setLayout('layout-class-5')">
            <div class="description">2 Dimension 5</div>
            <div class="preview-wrapper layout-class-5">
                <div class="bg-img-layer"></div>
                <div class="fill-layer"></div>
                <div class="content-layer">
                    <div class="header-container">
                        <div>Header</div>
                    </div>
                    <div class="text-container">
                        <div>Text</div>
                    </div>
                    <div class="footer-container">
                        <div>Footer</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="option" (click)="setLayout('layout-class-6')">
            <div class="description">2 Dimension 6</div>
            <div class="preview-wrapper layout-class-6">
                <div class="bg-img-layer"></div>
                <div class="fill-layer"></div>
                <div class="content-layer">
                    <div class="header-container">
                        <div>Header</div>
                    </div>
                    <div class="text-container">
                        <div>Text</div>
                    </div>
                    <div class="footer-container">
                        <div>Footer</div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- <div class="layout-width-picker">
        <div class="element-value-section">
            <div class="element-selector">
                <nb-actions size="tiny">
                    <nb-action>
                        <div class="title">Width:</div>
                    </nb-action>
                    <nb-action class="popover-icon"
                        (selectedWidth)="setWith($event)"
                        [nbPopover]="widthPop" 
                        [nbPopoverContext]="{title:'Set content width',isPopup:true,currentValue:contentWidth_n}" 
                        nbPopoverPlacement="top">
                            <button nbButton size="tiny">{{contentWidth_n}}%</button>
                    </nb-action>
                </nb-actions>
            </div>
            <div class="element-selector">
                <nb-actions size="tiny">
                    <nb-action>
                        <div class="title">H Align</div></nb-action>
                </nb-actions>
            </div>
            <div class="element-values">
                <nb-actions size="tiny">
                    <nb-action title="H Align Left" (click)="setCellHorizontalAlign('justify-left')" class="popover-icon">
                        <svg viewBox="0 0 24 24" id="ic_format_align_left_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z" />
                        </svg>
                    </nb-action>
                    <nb-action title="H Align Center" (click)="setCellHorizontalAlign('justify-center')" class="popover-icon">
                        <svg viewBox="0 0 24 24" id="ic_format_align_center_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z" />
                        </svg>
                    </nb-action>
                    <nb-action title="H Align Right" (click)="setCellHorizontalAlign('justify-right')" class="popover-icon">
                        <svg viewBox="0 0 24 24" id="ic_format_align_right_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z" />
                        </svg>
                    </nb-action>
                </nb-actions>
            </div>
            <div class="element-selector">
                <nb-actions size="tiny">
                    <nb-action>
                        <div class="title">V Align:</div>
                    </nb-action>
                </nb-actions>
            </div>
            <div class="element-values">
                <nb-actions size="tiny"> -->
                    <!-- <nb-action class="popover-icon"
                    (selectedWidth)="setWith($event)"
                    [nbPopover]="widthPop" 
                    [nbPopoverContext]="{title:'Set content width',isPopup:true,currentValue:contentWidth_n}" 
                    nbPopoverPlacement="top">
                        <button nbButton size="tiny">{{contentWidth_n}}%</button>
                    </nb-action> -->
                    <!-- <nb-action title="V Align Top" (click)="setCellVerticalAlign('top')" class="popover-icon">
                        <svg viewBox="0 0 24 24" id="ic_vertical_align_top_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z" />
                        </svg>
                    </nb-action>
                    <nb-action title="V Align Middle" (click)="setCellVerticalAlign('middle')" class="popover-icon">
                        <svg viewBox="0 0 24 24" id="ic_vertical_align_center_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z" />
                        </svg>
                    </nb-action>
                    <nb-action title="V Align Bottom" (click)="setCellVerticalAlign('bottom')" class="popover-icon">
                        <svg viewBox="0 0 24 24" id="ic_vertical_align_bottom_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z" />
                        </svg>
                    </nb-action>
                </nb-actions>
            </div>
            <div class="element-selector">
                <nb-actions size="tiny">
                    <nb-action>
                        <div class="title">Height in container</div>
                    </nb-action>
                </nb-actions>
            </div>
            <div class="element-values">
                <nb-actions size="tiny">
                    <nb-action>
                        <nb-radio-group [value]="selectedHeight" (valueChange)="onHeightChange($event)">
                            <nb-radio *ngFor="let option of heightOptions" [value]="option">{{option.name}}</nb-radio>
                        </nb-radio-group>
                    </nb-action>
                </nb-actions>
            </div>
        </div>
    </div> -->
    <kve-banner-layout-templates [isCreate]="false" (pickLayout)="setLayout($event)"></kve-banner-layout-templates>


